import { showcasesShown } from '../../configs/vitrine'

export const filterByShowcasesShown = (data) => {
  if (!data) {
    return []
  }

  return data.filter((showcase) => {
    return showcasesShown.indexOf(showcase.feature) !== -1
  })
}
